import CryptoJS from "crypto-js"

const SECRET_KEY = "chave-secreta"

export const criptografarDados = (data) => {
  if (data instanceof Map)  data = Object.fromEntries(data);
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};


export const criptografarDadosBase64 = (data) => {
  return CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(data));
};

export const decriptografarDados = (data) => {
    try {
        const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    } catch (error) {
        // console.error("Error decrypting data:", error)
        return null
    }
}